<template lang="pug">
  v-layout(style="position:relative")
    v-card.box-tarjeta-detalle-mis-metas(:style="{'backgroundColor':background, 'opacity': (bloqueado) ? '0.3' :'1'}")
      v-card-text
        v-layout(column)
          v-flex(v-if="meta")
            CardIconTextDobleRow(
              :icon="meta.icon"
              :text="meta.text"
              :detail="meta.detail"
              :dream="true"
            )
          v-flex.box-icon-meta(v-if="numeroMeta")
            div
              span {{numeroMeta || 'Meta1'}}
          v-flex.box-icon-meta(v-if="anhoActual")
            span(style="font-size: 15px;color: #454A6C;") {{anhoActual}}
          v-flex.box-monto-mensaje1
            span(style="display:block") {{tipoMoneda}} {{monto}}
          v-flex.box-monto-mensaje2
            span(style="display:block") {{mensajeMontoPorAcumular}}
          v-flex
            v-layout(style="height: 3em;position: relative;" column)
              v-flex.box-barra-progreso(v-if="metaAlcanzada")
                .box-barra1
                .box-barra2(:style="{ 'width': porcentaje + '%' }")
                  .box-icon-barra-progreso
                    v-img
                      img(:src="iconStart")
              v-flex.box-barra-progreso(v-if="!metaAlcanzada")
                .box-barra1(:style="{'backgroundColor': background ? '#ffffff' : ''}")
                  div(v-if="fechaDescripcionFaltan")
                    v-tooltip(bottom color="#454A6C" close-delay debounce v-model="show1")
                      template(v-slot:activator="{on}")
                        .box-icon-barra-progreso(v-on="on" @click="showTooltip('faltan')")
                      .box-tooltip-mensaje(style="line-height:14px; text-align:center;")
                        span(style="color:#ffffff !important; font-family:'Omnes Semibold'") Te faltan
                        br
                        span(style="color:#ffffff !important; font-family:'Omnes Semibold'") {{fechaDescripcionFaltan}}
                .box-barra2.box-barra-por-completar(:id="asignarId")
                  v-tooltip(bottom color="#ffffff" close-delay debounce v-model="show2")
                    template(v-slot:activator="{on}")
                      .box-icon-barra-progreso(v-on="on" @click="showTooltip('hoy')")
                    .box-tooltip-mensaje(style="line-height:14px; text-align:center;")
                      span(style="color:#000000 !important; color: #454A6C; font-family:'Omnes Semibold'") Hoy {{fechaDescripcionHasta}}
                      br
                      span(style="color:#000000 !important; color: #0855C4; font-family:'Omnes Medium'") {{mensajeTooltip}}

              v-flex
                v-layout
                  v-flex
                    span(style="font-size: 12px;") {{fechaInicial || '29/02/2022'}}
                  v-flex(style="text-align: end")
                    span(style="font-size: 12px;" :style="metaAlcanzada ? 'color: #FFC43A' :''" ) {{fechaFinal || '29/012/2022'}}
          v-flex.box-mensaje-final
            span {{mensajeFinal}}
    v-card.box-tarjeta-detalle-mis-metas(:style="{'display': (bloqueado) ? 'initial' :'none'}")
      v-layout.lock( align-center justify-center column fill-height )
        v-flex
          v-img
            img(:src="iconlock")
        v-flex(style="line-height: normal; margin-top:0.5em")
          span ¡Estás a un paso de obtener un nuevo beneficio!

</template>

<script>
import * as d3 from 'd3'
import CardIconTextDobleRow from '../generic/CardIconTextDoubleRow.vue'

export default {
  props: [
    'numeroMeta',
    'tipoMoneda',
    'montoPorAcumular',
    'porcentajeAlcanzado',
    'mensajeMontoPorAcumular',
    'fechaInicial',
    'fechaFinal',
    'mensajeFinal',
    'switchStyle',
    'anhoActual',
    'lock',
    'background',
    'idUnique',
    'totalPagoEfectuado',
    'mensajeTooltip',
    'meta',
    'fechaDescripcionHasta',
    'fechaDescripcionFaltan'
  ],
  data () {
    return {
      iconStart: require('./../../assets/icons-mis-seguros/icon-estrella-barra-progreso.svg'),
      iconlock: require('./../../assets/icons/icon-lock-gris.svg'),
      porcentaje: this.porcentajeAlcanzado,
      metaAlcanzada: false,
      bloqueado: false,
      monto: 0,
      idCard: '',
      show1: false,
      show2: false
    }
  },
  beforeDestroy () {
    clearTimeout(this.timerId)
  },
  components: {
    CardIconTextDobleRow
  },
  methods: {
    validarMeta () {
      if (this.porcentaje === 1) {
        this.metaAlcanzada = true
      }
      this.porcentaje *= 100
    },
    showTooltip (tooltip) {
      if (tooltip === 'faltan') {
        this.show1 = true
        this.timerId = setTimeout(() => { this.show1 = false }, 2000)
      } else {
        this.show2 = true
        this.timerId = setTimeout(() => { this.show2 = false }, 2000)
      }
    }
  },
  mounted () {
    let self = this
    // ASIGNANDO ID A TARJETA
    self.idCard = self.idUnique || ''

    self.bloqueado = self.lock
    if (!isNaN(self.montoPorAcumular)) {
      self.monto = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(self.montoPorAcumular)
    } else {
      self.monto = self.montoPorAcumular
    }
  },
  computed: {
    asignarId () {
      return this.idUnique
    }

  },
  updated () {
    let self = this
    let AuxPorcentaje = self.porcentaje * 100
    this.metaAlcanzada = AuxPorcentaje == 100
    // BARRA ID ASIGNADA
    let id = self.idUnique
    let w2 = d3.select('#' + id)

    w2.transition().delay(500).duration(2500)
      .style('width', AuxPorcentaje + '%')
  }

}
</script>

<style scoped>
.box-tarjeta-detalle-mis-metas {
  background: #FFFFFF;
  border: 1px solid #ededed;
  border-radius: 10px;
  padding-right: 1em;
  padding-left: 0.4em;
  max-width: 30em;
  width: 30em;
  max-height: 17.5em;
  box-shadow: 0px 0px;
}

.box-tarjeta-detalle-mis-metas:hover {
  border: 1px solid #0855c4;
}

.box-tarjeta-detalle-mis-metas:last-child {
  position: absolute;
  height: 100%;
  width: 100%;
  background: #d9d9d9b0;
  padding: 0;
}

.box-tarjeta-detalle-mis-metas:last-child:hover {
  border: 1px solid #d9d9d9;
}

.box-tarjeta-detalle-mis-metas:last-child .lock {
  height: fit-content !important;
  width: 18em;
  text-align: center;
  margin-top: 3em;
  margin-bottom: auto;
  margin-right: auto;
  margin-left: auto;
}

.box-tarjeta-detalle-mis-metas:last-child .lock span {
  font-size: 16px;
  color: #807F7F;
}

.box-tarjeta-detalle-mis-metas .v-card__text {
  padding: 0.5em 1em 1.1em 1.1em;
}

.box-tarjeta-detalle-mis-metas .box-icon-meta div {
  background: var(--green-color);
  border-radius: 1em;
  padding: 0 1em;
  margin-bottom: 0.5em;
  width: fit-content;
}

.box-tarjeta-detalle-mis-metas .box-icon-meta span {
  color: #ffffff;
  font-size: 15px;
}

.box-tarjeta-detalle-mis-metas .box-monto-mensaje1 {
  margin-top: 0.2em;
  line-height: normal;
}

.box-tarjeta-detalle-mis-metas .box-monto-mensaje2 {
  margin-bottom: 0.5em;
  line-height: normal;
}

.box-tarjeta-detalle-mis-metas .box-monto-mensaje1 span {
  font-size: 24px;
  color: var(--text-color);
}

.box-tarjeta-detalle-mis-metas .box-monto-mensaje2 span {
  font-size: 13px;
  color: var(--second-brand-color);

}

.box-tarjeta-detalle-mis-metas .box-mensaje-final {
  text-align: center;
  margin-top: 1em;
  line-height: normal;
}

.box-tarjeta-detalle-mis-metas .box-barra-progreso {
  position: relative;
  height: 1.3em;
  display: flex;
  align-items: center;
}

.box-tarjeta-detalle-mis-metas .box-barra-progreso .box-barra1 {
  height: inherit;
  border-radius: 1em;
  position: absolute;
  width: 100%;
  background: #eaecf2;
}

.box-tarjeta-detalle-mis-metas .box-barra-progreso .box-barra2 {
  height: inherit;
  border-radius: 1em;
  position: absolute;
  width: 0%;
  background: #0855C4;
}

.box-tarjeta-detalle-mis-metas .box-barra-progreso .box-barra-por-completar {
  border-radius: 1em 0em 0em 1em;
}

.box-tarjeta-detalle-mis-metas .box-barra-progreso .box-barra-por-completar .box-tooltip-mensaje {
  text-align: center !important;
  line-height: 13px !important;
  font-size: 17px !important;
}

.box-tarjeta-detalle-mis-metas .box-barra-progreso .box-barra-por-completar .box-tooltip-mensaje span {
  color: #ffffff !important;
}

.box-tarjeta-detalle-mis-metas .box-barra-progreso .box-barra-por-completar .v-tooltip__content {
  position: relative;
  top: 22px !important;
  background: #ffffff;
  border-radius: 5px;
  height: 0.7em;
  display: initial !important;
}

.box-tarjeta-detalle-mis-metas .box-barra-progreso .box-barra2 .box-icon-barra-progreso {
  position: absolute;
  top: -18px;
  right: -25px;
}

.box-tarjeta-detalle-mis-metas .box-barra-progreso .box-barra-por-completar .box-icon-barra-progreso {
  position: absolute;
  top: 1em;
  right: -0.2em;
  height: 0.5em;
  width: 0.5em;
  border-radius: 1em;
  background: #000000;
}

.box-tarjeta-detalle-mis-metas .box-barra-progreso .box-barra1 .box-icon-barra-progreso {
  position: absolute;
  top: 1em;
  right: 0.4em;
  height: 0.5em;
  width: 0.5em;
  border-radius: 1em;
  background: #000000;
}

.box-tarjeta-detalle-mis-metas .box-barra-progreso .box-barra1 .box-tooltip-mensaje {
  text-align: center !important;
  line-height: 13px !important;
  font-size: 17px !important;
}

.box-tarjeta-detalle-mis-metas .box-barra-progreso .box-barra1 .box-tooltip-mensaje span {
  color: #ffffff !important;
}

.box-tarjeta-detalle-mis-metas .box-barra-progreso .box-barra1 .v-tooltip__content {
  position: relative;
  top: 22px !important;
  background: #ffffff;
  border-radius: 5px;
  height: 0.7em;
  display: initial !important;
}

.box-tarjeta-detalle-mis-metas .box-mensaje-final span {
  font-size: 14px;
  color: #0855C4;
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/TarjetaDetalleMisMetas.vue